import useNswagClient from '../../hooks/api/useNswagClient';
import { useContext, useState } from 'react';
import { UserContext } from '../../components/shared/useUser';
import { ConfigurationName } from '../../enums/ConfigurationName';

const useConfigurationBoolean = (configName: ConfigurationName) => {
  const { selectedStore } = useContext(UserContext);
  const { getConfiguration } = useNswagClient();
  const [value, setValue] = useState<boolean>(false);

  const getConfigurationValue = async  () => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const res: any = await getConfiguration(configName, selectedStore?.storeNumber ?? '', selectedStore?.franchiseName ?? '');
      setValue(res.data.value === 'true');
    } catch (error) {
      console.error(`Error fetching ${configName} configuration:`, error);
    }
  };

  return {
    value,
    getConfigurationValue,
  };
};

export const useVoidTransactionEnabledConfiguration = () => {
  const { value, getConfigurationValue } = useConfigurationBoolean(ConfigurationName.VoidTransactionEnabled);

  return {
    voidTransactionEnabled: value,
    getVoidTransactionEnabledConfiguration: getConfigurationValue,
  };
};
